import React from "react";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const OrderSummary = (props) => {
    const {
        subtotal,
        shippingAmount,
        productDiscountAmount,
        discountAmount,
        totalAmount,
        discountApplied,
        couponLoading,
        couponMessage,
        appliedCoupon,
        handlePaymentMethodChange,
        productFormData,
        loading,
        onCreateOrder,
        removeCoupon,
        setCouponCode,
        couponCode,
        applyCoupon,
        currencySymbol = "",
    } = props;

    const hasSubtotal = Number(subtotal || 0) > 0;
    const isCashOnDelivery = productFormData.paymentMethod === "cash_on_delivery";
    const payableAmount = isCashOnDelivery
        ? Math.max(
            0,
            Number(subtotal || 0) +
                Number(shippingAmount || 0) -
                Number(productDiscountAmount || 0)
        )
        : Number(totalAmount || 0);

    return (
        <div className="cart-paydetail w-100">
            <div className="order-total d-flex justify-content-start align-items-center">
                <span className="main-total fw-bold">Order Summary</span>
            </div>

            {!isCashOnDelivery && discountApplied ? (
                <div className="applied_discount_message col-12">
                    <span className="coupon_code_applied">
                        Coupon Code Applied ({appliedCoupon?.code || couponCode}): {currencySymbol}{" "}
                        {Number(discountAmount || 0).toFixed(2)}
                    </span>
                    <button className="remove_button" onClick={removeCoupon}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Bold"
                            viewBox="0 0 24 24"
                            width="25"
                            height="25"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            xmlnsSvgjs="http://svgjs.dev/svgjs"
                        >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path
                                    d="M14.121,12L18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z"
                                    fill="#fc722d"
                                    fillOpacity="1"
                                    stroke="none"
                                    strokeOpacity="1"
                                />
                            </g>
                        </svg>
                    </button>
                </div>
            ) : !isCashOnDelivery ? (
                <div className="coupon_input mb-2 mt-3 d-flex">
                    <input
                        type="text"
                        className="col-9"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                        placeholder="Enter Coupon Code"
                    />
                    <button
                        type="button"
                        className="col-3 web_buttons"
                        onClick={() => applyCoupon()}
                        disabled={couponLoading}
                    >
                        {couponLoading ? "..." : "Apply"}
                    </button>
                </div>
            ) : null}

            {!isCashOnDelivery && !discountApplied && couponMessage ? (
                <div className="mb-2">
                    <span className="text-white">{couponMessage}</span>
                </div>
            ) : null}

            <div className="payment-detail mb-3">
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="subtotal">Subtotal</span>
                    <span className="amount">{currencySymbol} {subtotal}</span>
                </div>
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="shipping">Shipping (Standard)</span>
                    <span className="amount">
                        {Number(shippingAmount || 0) > 0
                            ? `${currencySymbol} ${Number(shippingAmount || 0).toFixed(2)}`
                            : "Free"}
                    </span>
                </div>
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="left_heading">Discount</span>
                    <span className="right_text">
                        {currencySymbol} {Number(productDiscountAmount || 0).toFixed(2)}
                    </span>
                </div>
                {!isCashOnDelivery && discountApplied && (
                    <div className="card-border-bottom d-flex justify-content-between align-items-center">
                        <span className="left_heading">Coupon Discount</span>
                        <span className="right_text">
                            {currencySymbol} {Number(discountAmount || 0).toFixed(2)}
                        </span>
                    </div>
                )}
                <div className="card-border-bottom d-flex justify-content-between align-items-center">
                    <span className="subtotal">Total</span>
                    <span className="amount">{currencySymbol} {Number(payableAmount || 0).toFixed(2)}</span>
                </div>
            </div>

            <div className="payment_method_wrapper mb-3">
                <p className="payment_method_title mb-2">Payment Method</p>
                <label className="payment_method_option">
                    <input
                        className="select_address_button"
                        type="radio"
                        name="paymentmode"
                        value="online_payment"
                        onChange={handlePaymentMethodChange}
                        checked={(productFormData.paymentMethod || "online_payment") === "online_payment"}
                    />
                    <span>Online Payment</span>
                </label>
                <label className="payment_method_option">
                    <input
                        className="select_address_button"
                        type="radio"
                        name="paymentmode"
                        value="cash_on_delivery"
                        onChange={handlePaymentMethodChange}
                        checked={productFormData.paymentMethod === "cash_on_delivery"}
                    />
                    <span>Cash on Delivery</span>
                </label>
            </div>

            {hasSubtotal ? (
                <div className="checkout mt-md-2 pt-2">
                    <button className="" onClick={onCreateOrder} disabled={loading}>
                        {loading ? <ClipLoader color="#fff" size={20} /> : "Place Order"}
                    </button>
                </div>
            ) : (
                <button className="cart_btn_add">
                    <Link to="/">Continue Shopping</Link>
                </button>
            )}
        </div>
    );
};

export default OrderSummary;
